import { render, staticRenderFns } from "./CardProfitLoss.vue?vue&type=template&id=79aedb7f&scoped=true&"
import script from "./CardProfitLoss.vue?vue&type=script&lang=ts&"
export * from "./CardProfitLoss.vue?vue&type=script&lang=ts&"
import style0 from "./CardProfitLoss.vue?vue&type=style&index=0&id=79aedb7f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aedb7f",
  null
  
)

export default component.exports